import { useQuery } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

interface UseFolderDetailCategoriesParams {
  folderSno: number;
}

export const useFolderDetailCategories = ({
  folderSno,
}: UseFolderDetailCategoriesParams) => {
  return useQuery({
    queryKey: queryKey.folderDetailCategories(folderSno),
    queryFn: () =>
      likedFolderService.getFolderDetailCategories({ folder_sno: folderSno }),
  });
};
